import { gql } from "@apollo/client";

export const GET_POD_REVIEW_REVIEWERS = gql`
    query GetPodReviewReviewers {
        getPodReviewReviewers {
            id
            name
            phone
        }
    }
`;

export interface PodReviewReviewerType {
    id: string;
    name: string;
    phone?: string;
}

export interface GetPodReviewReviewersResponse {
    getPodReviewReviewers: PodReviewReviewerType[];
}

